import React, { Component } from 'react';
import '../css/App.css';
import API from '../config_api'
import axios from 'axios'
import { Doughnut } from 'react-chartjs-2';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Collapse from "@kunukn/react-collapse";
import Sidenav from './Sidenav';
class Insight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            data1: [],
            data2: [],
            insights: '',
            red: '',
            blue: '',
            orange: '',
            green: '',
            percentage: '',
            isOpen: false,
            isOpen1: false

        };

    }

    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/');
        }
        let formData = new FormData();
        formData.append('user_id', localStorage.getItem('token'))
        axios({
            method: 'post',
            url: API.UserReport,
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {
                // this.setState({ red: res.data.data.insights.red })
                // this.setState({ green: res.data.data.insights.green })
                // this.setState({ red: res.data.data.insights.blue })
                // this.setState({ orange: res.data.data.insights.orange })
                this.setState({ insights: res.data.data.insights })
                this.setState({ percentage: res.data.data.overall_percentage })

            });
        let formData1 = new FormData();
        formData1.append('user_id', localStorage.getItem('token'))
        formData1.append('company_id', localStorage.getItem('company_no'));
        axios({
            method: 'post',
            url: API.TopArea,
            data: formData1,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {
                this.setState({ data: res.data.data })


            });
        axios({
            method: 'post',
            url: API.NotAttentedUnits,
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {

                this.setState({ data1: res.data.data })


            });
        axios({
            method: 'post',
            url: API.UserAreaDropDown,
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {
                console.log(res.data.data);

                this.setState({ data2: res.data.data })

            });


    }
    btnAction(data) {
        console.log(data);
        this.props.history.push('/units/' + data.program_id)
        localStorage.setItem('unit_name', data.title)
    }
    Onpress() {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }
    Onpress1() {
        this.setState(prevState => ({
            isOpen1: !prevState.isOpen1
        }));
    }
    selectOption(event) {

        let formData = new FormData();
        formData.append('user_id', localStorage.getItem('token'));
        if (event.target.value !== '0') {
            formData.append('area_id', event.target.value);
            axios({
                method: 'post',
                url: API.AreaLevelInsight,
                data: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                mode: 'no-cors',
            })
                .then(res => {
                    console.log(res.data.data);

                    // this.setState({ red: res.data.data.insights.red })
                    // this.setState({ green: res.data.data.insights.green })
                    // this.setState({ red: res.data.data.insights.blue })
                    // this.setState({ orange: res.data.data.insights.orange })
                    this.setState({ insights: res.data.data.insights })
                    this.setState({ percentage: res.data.data.overall_percentage })

                });
        }
        else {
            axios({
                method: 'post',
                url: API.UserReport,
                data: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                mode: 'no-cors',
            })
                .then(res => {
                    // this.setState({ red: res.data.data.insights.red })
                    // this.setState({ green: res.data.data.insights.green })
                    // this.setState({ red: res.data.data.insights.blue })
                    // this.setState({ orange: res.data.data.insights.orange })
                    this.setState({ insights: res.data.data.insights })
                    this.setState({ percentage: res.data.data.overall_percentage })

                });
        }
    }
    render() {
        return (
            <div className="">
                {/* <Sidenav type={'second'} url={'/dashboard'} /> */}

                <nav class="navbar navbar-top navbar-expand navbar-dark  border-bottom" style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        top: 0,
                        zIndex: 1
                    }}>
                    <div class="container pad_z">
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <div className="col-sm-3 pad_z ">
                                <i className="material-icons back-btn grey-text" onClick={() => this.props.history.goBack()}>arrow_back</i>
                            </div>
                            <div className="col-sm-6 text-center pad_z" style={{fontSize:20}}> Insights</div>
                            <div className="col-sm-3 text-right  pad_z vertical-align justify-content-end"></div>

                        </div>
                    </div>
                </nav>

                <div className="container" style={{marginTop:70}}>

                    <div className="row">
                        <div className="col-sm-12">
                            <label className="mt-3" style={{ fontSize: 20 }}>Select Topic</label>
                            <select class="form-control" style={{ border: 0, borderBottom: "1px solid", marginBottom: 20, borderRadius: 0 }} onChange={(event) => this.selectOption(event)}>
                                {this.state.data2.map((data, i) =>
                                    <option value={data.value} key={i}>{data.label}</option>
                                )}

                            </select>
                            <div className="card flex horizontal" >
                                <div style={{fontSize:20}}>Knowledge Index</div>
                                <div className="flex justify-content-center">
                                    <div style={{ width: 320, height: 'auto', position: 'relative' }}>
                                        <div className="index" style={{ fontSize: 40, bottom: 25,fontWeight:500 }}>{this.state.insights.insight_index === null ?"No Data":Math.round(this.state.insights.insight_index)}</div>
                                        <Doughnut
                                            data={{
                                                labels: ['High Risk', 'Lucky', 'Low Risk',
                                                    'Risky'],
                                                datasets: [
                                                    {

                                                        backgroundColor: [
                                                            '#be1f24',
                                                            '#005284',
                                                            '#7ed321',
                                                            '#f5a623'
                                                        ],
                                                        hoverBackgroundColor: [
                                                            '#be1f24',
                                                            '#005284',
                                                            '#7ed321',
                                                            '#f5a623'
                                                        ],
                                                        borderWidth: 0,
                                                        data: [Math.round(this.state.insights.red), Math.round(this.state.insights.blue), Math.round(this.state.insights.green), Math.round(this.state.insights.orange)]
                                                    }
                                                ]
                                            }}

                                            width={120}
                                            height={100}
                                            options={{
                                                title: {
                                                    display: false,

                                                },
                                                legend: {
                                                    display: true,
                                                    position: "bottom",
                                                    labels: {
                                                        boxWidth:10
                                                    }
                                                    
                                                },
                                                cutoutPercentage: 80
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="card flex horizontal">
                                <div style={{fontSize:20}}> Pull Rate</div>
                                <div className="flex justify-content-center" >
                                    <div style={{ width: 240, height: 'auto' }}>
                                        <CircularProgressbar value={this.state.percentage} text={`${Math.round(this.state.percentage)}%`} strokeWidth={8}/></div>
                                </div>
                            </div>
                            <div className="horizontal" style={{ padding: 0 }}>
                                <div className="card row" style={{ padding: 10, margin: 0, height: 45 }} onClick={() => this.Onpress1()} >
                                    <div className="col-sm-11 col-xs-11 padZero flex align-space-between" style={{fontSize:20}}><div>Units not Viewed</div>
                                        <span className="topic">{this.state.data1.length} Unit(s) </span>
                                    </div>
                                    <div className="col-sm-1 col-xs-1 pad_z"> {this.state.isOpen1 === true ?
                                        <i className="material-icons">
                                            keyboard_arrow_down
</i> : <i className="material-icons">
                                            keyboard_arrow_right
</i>}</div>
                                </div>
                                <Collapse isOpen={this.state.isOpen1} >
                                    {this.state.isOpen1 === true ?
                                        this.state.data1.map((data, i) =>
                                            <div className="unit_assign col-sm-12" key={i} onClick={() => this.btnAction(data)}>
                                                <div className="col-sm-11 col-xs-11 pad_z">{data.title}</div>
                                                <div className="col-sm-1 col-xs-1 pad_z"><i className="material-icons">
                                                    keyboard_arrow_right
</i></div>

                                            </div>) : ''}
                                </Collapse>
                            </div>
                            <div className="horizontal" style={{ padding: 0 }}>
                                <div className="card row " style={{ padding: 10, margin: 0, height: 45 }} onClick={() => this.Onpress()} >
                                    <div className="col-sm-11 col-xs-11 pad_z flex align-space-between"><div style={{fontSize:20}}>Trending Units</div>
                                        <span className="topic">{this.state.data.length} Unit(s) </span></div> <div className="col-sm-1 col-xs-1 pad_z"> {this.state.isOpen === true ?
                                            <i className="material-icons">
                                                keyboard_arrow_down
</i> : <i className="material-icons">
                                                keyboard_arrow_right
</i>}</div>
                                </div>
                                <Collapse isOpen={this.state.isOpen} >
                                    {this.state.isOpen === true ?
                                        this.state.data.map((data, i) =>
                                            <div className="unit_assign col-sm-12" key={i} onClick={() => this.btnAction(data)}>
                                                <div className="col-sm-11 col-xs-11 pad_z">{data.title}</div>
                                                <div className="col-sm-1 col-xs-1 pad_z"><i className="material-icons">
                                                    keyboard_arrow_right
</i></div>

                                            </div>) : ''}
                                </Collapse>
                            </div>
                        </div>
                    </div></div></div>
        )
    }
}
export default Insight;